import React, { useState, useEffect } from "react";
import { useUIStore } from "../../store/uiStore"; // Corrected import path
// No longer need useChatStore here for setChatViewMode
// import { useChatStore } from '../../store/chatStore';
import styles from "./ChatBubble.module.css"; // Import the CSS module
import { ChatBubbleIcon } from "../common/Icons"; // Import the new icon
import useAuthStore from "../../store/authStore"; // Import authStore
import { initializeChatData } from "../../App"; // Import the initialize function
import { logDebug } from "../../utils/logging"; // Import logging utility
import { WELCOME_MESSAGES } from "../../utils/constants"; // Import the messages
import { trackEvent } from "../../services/analyticsService"; // Import analytics service

// No props needed for this component currently
// interface ChatBubbleProps {
//   // Props if any, e.g., initial text, icon
// }

const ChatBubble: React.FC = () => {
  const openChatToSidebar = useUIStore((state) => state.openChatToSidebar);
  const setIsInitializingChat = useUIStore(
    (state) => state.setIsInitializingChat,
  );
  const isLoadingInitialData = useAuthStore(
    (state) => state.isLoadingInitialData,
  );
  const initialDataLoaded = useAuthStore((state) => !!state.jwt);

  const setLoadingInitialData = useAuthStore(
    (state) => state.setLoadingInitialData,
  );
  const setInitialData = useAuthStore((state) => state.setInitialData);
  const setInitialDataError = useAuthStore(
    (state) => state.setInitialDataError,
  );

  const [welcomeMessage, setWelcomeMessage] = useState("");
  const [isWelcomeMessageVisible, setIsWelcomeMessageVisible] = useState(true);
  const [isBubbleReady, setIsBubbleReady] = useState(false);

  useEffect(() => {
    // Check if dismissed previously
    const dismissed = sessionStorage.getItem("smartieWelcomeMessageDismissed");
    if (dismissed === "true") {
      setIsWelcomeMessageVisible(false);
      setIsBubbleReady(true); // No need for animation if already dismissed
      return; // Exit early if already dismissed
    }

    const storedMessage = sessionStorage.getItem("smartieWelcomeMessage");
    if (storedMessage) {
      setWelcomeMessage(storedMessage);
    } else {
      const randomIndex = Math.floor(Math.random() * WELCOME_MESSAGES.length);
      const randomMessage = WELCOME_MESSAGES[randomIndex];
      sessionStorage.setItem("smartieWelcomeMessage", randomMessage);
      setWelcomeMessage(randomMessage);
    }

    const timer = setTimeout(() => {
      setIsBubbleReady(true);
    }, 5000); // 5-second delay

    return () => clearTimeout(timer);
  }, []);

  const handleOpenChat = async () => {
    // Track widget open event once per session
    const hasTrackedOpen = sessionStorage.getItem("smartieWidgetOpened");
    if (!hasTrackedOpen) {
      trackEvent("widget_opened", {
        welcome_message_variant: welcomeMessage,
      });
      sessionStorage.setItem("smartieWidgetOpened", "true");
    }

    // Dismiss the welcome message if the user opens the chat or clicks the bubble
    setIsWelcomeMessageVisible(false);
    sessionStorage.setItem("smartieWelcomeMessageDismissed", "true");

    if (isLoadingInitialData) {
      logDebug("Chat bubble clicked. Initial data is already loading.");
      return;
    }

    if (initialDataLoaded) {
      logDebug(
        "Chat bubble clicked. Initial data already loaded. Opening to sidebar.",
      );
      openChatToSidebar();
      return;
    }

    logDebug(
      "Chat bubble clicked. Setting initializing state and opening sidebar...",
    );
    setIsInitializingChat(true);
    openChatToSidebar();

    logDebug("Chat bubble: Now attempting to initialize chat data...");
    await initializeChatData(
      setLoadingInitialData,
      setInitialData,
      setInitialDataError,
    );

    logDebug(
      "Chat bubble: Chat data initialization complete. Clearing initializing flag.",
    );
    setIsInitializingChat(false);
  };

  const handleCloseWelcomeMessage = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsWelcomeMessageVisible(false);
    sessionStorage.setItem("smartieWelcomeMessageDismissed", "true"); // Persist dismissal
  };

  // This onClick handler is for the message bubble itself
  const handleBubbleClick = (e: React.MouseEvent) => {
    // We want to stop propagation if the user is, for example, selecting text.
    // However, for this simple bubble, we can assume any click should open the chat.
    // Let's check if the click was on the close button, just in case.
    if ((e.target as HTMLElement).closest(`.${styles.closeButton}`)) {
      return;
    }
    handleOpenChat();
  };

  return (
    <div className={styles.widgetContainer}>
      {isBubbleReady && isWelcomeMessageVisible && welcomeMessage && (
        <div className={styles.messageBubble} onClick={handleBubbleClick}>
          <button
            onClick={handleCloseWelcomeMessage}
            className={styles.closeButton}
          >
            &times;
          </button>
          <p className={styles.messageText}>{welcomeMessage}</p>
        </div>
      )}
      <button
        onClick={handleOpenChat}
        className={styles.chatBubble}
        aria-label="Deschide widgetul de chat"
        title="Deschide widgetul de chat"
      >
        <ChatBubbleIcon
          className={styles.chatBubbleIcon}
          title="Pictogramă chat"
        />
      </button>
    </div>
  );
};

export default ChatBubble;
